
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div class=\"card\">\n  <header class=\"mb-4\">\n    <h1 id=\"fxa-cannot-create-account-header\" class=\"card-header\">{{#t}}Cannot create account{{/t}}</h1>\n  </header>\n\n  <section>\n    <p>\n      {{#unsafeTranslate}}You must meet certain age requirements to create a Firefox&nbsp;account.{{/unsafeTranslate}}\n    </p>\n    <p class=\"mt-9\">\n      <a id=\"ftc\" class=\"link-blue\" href=\"{{ coppaUrl }}\" {{#isSync}} target=\"_blank\"{{/isSync}}>{{#t}}Learn more{{/t}}</a>\n    </p>\n\n  </section>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  